export {
    sendCustomEvent
}

function sendCustomEvent(name, detail = {}, target = document) {
    const customEvent = new CustomEvent(name, {
        bubbles: true,
        detail: detail
    })
    target.dispatchEvent(customEvent);
}
